import { gql } from '@apollo/client'
import { omit } from 'ramda'
import { useCleanFilterForRequest, useSearch } from '@btime/react-contexts'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useCalendarEventsState = () => React.useContext(Context) || {}
export const useCalendarEvents = () => useCalendarEventsState()?.calendarEvents || []

export const CALENDAR_EVENTS_LIMIT = 500

const QUERY = gql`
  query CalendarEvents($filter: CalendarEventFilter, $limit: Int) {
    calendarEvents(filter: $filter, limit: $limit, sort: { field: DATE, type: ASC }) {
      id
      name
      description
      checklist {
        id
        configuration
      }
      date
      color
      recordId
      recordType
    }
  }
`

const CalendarEventsLoader = ({ children, uncontrolledChildren }) => {
  const [date, setDate] = React.useState()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    skip: !date,
    variables: {
      search,
      limit: CALENDAR_EVENTS_LIMIT,
      filter: { date, ...omit(['endDate', 'insertedAt', 'scheduling'], filter) }
    },
    client: generalClient
  })

  return (
    <Provider value={{ ...data, loading: state.loading, setDate, date }}>
      <StatePresenter {...state} loading={false} empty={false} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default CalendarEventsLoader
